import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import OptimizedImage from '../components/OptimizedImage';
import { candidatesPageData } from '../data/pagesData';
import { Star, Play, ExternalLink } from 'lucide-react';

const CandidatesPage = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const { title, subtitle, testimonials } = candidatesPageData;
  const featured = testimonials.find(t => t.featured);
  const others = testimonials.filter(t => !t.featured);

  return (
    <div className="bg-[#F9FBF5] min-h-screen">
      <Navbar />
      {/* Hero */}
      <section className="max-w-[1280px] mx-auto px-6 lg:px-10 pt-16 lg:pt-24 pb-12 text-center">
        <h1 className="text-[#082900] text-[48px] lg:text-[72px] font-serif leading-tight mb-4">{title}</h1>
        <p className="text-[#082900]/70 text-lg font-inter max-w-xl mx-auto mb-8">{subtitle}</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/demo" className="px-8 py-4 bg-[#082900] text-white text-base font-medium rounded-full hover:bg-[#0A3900] transition-colors font-inter">Book a Demo</Link>
          <a href="https://youtu.be/Q7dqyoHUJ5I" target="_blank" rel="noopener noreferrer" className="px-8 py-4 border border-[#082900] text-[#082900] text-base font-medium rounded-full hover:bg-[#082900] hover:text-white transition-colors font-inter">Watch a 5 min demo</a>
        </div>
      </section>

      {/* Featured Testimonial */}
      {featured && (
        <section className="max-w-[1280px] mx-auto px-6 lg:px-10 pb-16">
          <div className="bg-[#EAE5D9] rounded-2xl overflow-hidden">
            <div className="flex flex-col lg:flex-row">
              <div className="lg:w-1/2 relative group cursor-pointer">
                <OptimizedImage src={featured.image} alt={featured.name} className="w-full h-full object-cover aspect-[4/3]" priority={true} />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center"><Play className="w-7 h-7 text-[#082900] ml-1" fill="#082900" /></div>
                </div>
              </div>
              <div className="lg:w-1/2 p-8 lg:p-14 flex flex-col justify-center">
                <p className="text-[#082900] text-xl lg:text-2xl font-serif font-bold leading-relaxed mb-8">"{featured.quote}"</p>
                <div className="flex items-center gap-1 mb-3">{[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-[#D4A843]" fill="#D4A843" />)}</div>
                <p className="text-[#082900] text-base font-semibold font-inter">{featured.name}</p>
                <p className="text-[#082900]/60 text-sm font-inter">{featured.title}</p>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Testimonial Grid */}
      <section className="max-w-[1280px] mx-auto px-6 lg:px-10 pb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {others.map((t, i) => (
            <div key={i} className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow">
              <div className="flex flex-col sm:flex-row">
                {/* Image + Play */}
                <div className="sm:w-2/5 relative group cursor-pointer">
                  <OptimizedImage src={t.image} alt={t.name} className="w-full h-full object-cover aspect-square sm:aspect-auto min-h-[200px]" />
                  <div className="absolute inset-0 bg-black/20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <div className="w-12 h-12 bg-white/90 rounded-full flex items-center justify-center"><Play className="w-5 h-5 text-[#082900] ml-0.5" fill="#082900" /></div>
                  </div>
                </div>
                {/* Content */}
                <div className="sm:w-3/5 p-5 lg:p-6 flex flex-col justify-between">
                  <div>
                    {t.hasLinkedIn && (
                      <div className="flex justify-end mb-2"><ExternalLink className="w-4 h-4 text-[#0A66C2]" /></div>
                    )}
                    <p className="text-[#082900]/80 text-sm font-inter leading-relaxed mb-4">"{t.quote}"</p>
                  </div>
                  <div>
                    <div className="flex items-center gap-1 mb-2">{[...Array(5)].map((_, j) => <Star key={j} className="w-3.5 h-3.5 text-[#D4A843]" fill="#D4A843" />)}</div>
                    <p className="text-[#082900] text-sm font-semibold font-inter">{t.name}</p>
                    <p className="text-[#082900]/50 text-xs font-inter">{t.title}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default CandidatesPage;
